module.exports = __webpack_public_path__ + "static/media/gadget-reward.31c36afb.png";